import {Component} from "../interface/component";
import {AnimationService} from "../service/animation";
import FocusProductSlide from "../animations/product-slide/focus-product-slide";
import HideByFade from "../animations/hide-by-fade";
import ShowByFade from "../animations/show-by-fade";
import HideAndShowByFade from "../animations/hide-and-show-by-fade";

export class ProductImageWithVideoComponent implements Component {

    protected defaultTimeout = 2000;
    protected timeout:number;
    protected $root:JQuery<any>;
    protected $image:JQuery<any>;
    protected $video:JQuery<any>;

    private animations: AnimationService;

    constructor(element:HTMLElement) {
        this.$root = $(element);
        this.timeout = this.$root.data('timeout') ? parseInt(this.$root.data('timeout')) : this.defaultTimeout;
        this.$image = this.$root.find('.js-product-image-with-video__image');
        this.$video = this.$root.find('.js-product-image-with-video__video');
    }

    init() {
        if (this.$video.length != 0) {
            setTimeout(this.hideImageAndStartVideo, this.timeout);
        }
    }

    hideImageAndStartVideo = () => {
        let video = (<JQuery<HTMLVideoElement>>this.$video.find('video')).get(0);
        video.play();
        video.onended = () => setTimeout(this.hideVideoOnStoppedVideo, this.timeout);
        this.animations.run(HideAndShowByFade, this.$image, {}, { duration: 0.5, show: this.$video });
    }

    hideVideoOnStoppedVideo = () => {
        this.animations.run(HideAndShowByFade, this.$video, {}, { duration: 0.5, show: this.$image });
    }

    setAnimationHandler(animations:AnimationService) {
        this.animations = animations;
        return this;
    }
}
